import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import StatisticsCard from './StatisticsCard';
import { actionStatisticsService, ActionStatistics } from '../../services/ActionStatisticsService';

const CancelledActionsCard: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<ActionStatistics | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await actionStatisticsService.getCancelledActions();
                setData(result);
            } catch (error) {
                console.error('Error fetching cancelled actions:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleClick = () => {
        navigate('/tw/plano-de-acao?situacao=Cancelada');
    };

    return (
        <StatisticsCard
            title="Canceladas"
            value={data?.count ?? 0}
            loading={loading}
            color="#f44336"
            icon={<CancelOutlinedIcon fontSize="large" />}
            subtitle="Ações canceladas"
            onClick={handleClick}
        />
    );
};

export default CancelledActionsCard;